import React from 'react';
import DeviationLink from '../../../Duperbrowse/DeviationLink';
import cleanLinkSrc from '../../../utils/xss/cleanLinkSrc';
import s from './DeviationLink.scss';
var getUrl = function (url) {
    if (!/^http/.test(url)) {
        return "http://".concat(url);
    }
    return url;
};
var EditorDeviationLink = function (_a) {
    var link = _a.link, deviation = _a.deviation, linkClass = _a.linkClass, children = _a.children;
    return (React.createElement("div", { className: s['link'] }, link ? (React.createElement("a", { href: cleanLinkSrc(getUrl(link.url)), rel: "nofollow noopener" }, children)) : (React.createElement(DeviationLink, { deviation: deviation, className: linkClass, canLinkToStash: deviation.isJournal }, children))));
};
EditorDeviationLink.displayName = 'EditorDeviationLink';
export default EditorDeviationLink;
//# sourceMappingURL=DeviationLink.js.map